import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CKEditorModule } from 'ng2-ckeditor';

import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { CkeditorComponent } from './ckeditor/ckeditor.component';
import { DatetimepickerComponent } from './datetimepicker/datetimepicker.component';
import { InboxComponent } from './inbox/inbox.component';
import { FilterPipe } from './pipes/filter.pipe';
import { SortPipe } from './pipes/sort.pipe';

import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { ButtonDatetimepickerComponent } from './button-datetimepicker/button-datetimepicker.component';
import { FormsModule } from '@angular/forms';
import { NotificationViewComponent } from './notification-view/notification-view.component';
import { MalihuScrollbarModule } from 'ngx-malihu-scrollbar';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { UploadedFileViewComponent } from './uploaded-file-view/uploaded-file-view.component';
import { ViewVideoModalComponent } from './view-video-modal/view-video-modal.component';
import { VideoUploadBtnComponent } from './video-upload-btn/video-upload-btn.component';
import { VideoLinkUploadModalComponent } from './video-link-upload-modal/video-link-upload-modal.component';
import { CheckPipe } from './pipes/check.pipe';
import { PureFilterPipe } from './pipes/pure-filter.pipe';
import { TooltipModule } from 'ngx-tooltip';
import { FindObjPipe } from './pipes/find-obj.pipe';
import { RangeSliderComponent } from './range-slider/range-slider.component';
import { StudentNamePipe } from './pipes/student-name.pipe';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    CKEditorModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    InfiniteScrollModule,
    MalihuScrollbarModule.forChild(),
    TooltipModule
  ],
  declarations: [
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    CkeditorComponent,
    DatetimepickerComponent,
    InboxComponent,
    FilterPipe,
    SortPipe,
    ButtonDatetimepickerComponent,
    NotificationViewComponent,
    UploadedFileViewComponent,
    ViewVideoModalComponent,
    VideoUploadBtnComponent,
    VideoLinkUploadModalComponent,
    CheckPipe,
    PureFilterPipe,
    FindObjPipe,
    RangeSliderComponent,
    StudentNamePipe
  ],
  entryComponents: [VideoLinkUploadModalComponent],
  exports: [
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    CkeditorComponent,
    DatetimepickerComponent,
    InboxComponent,
    FilterPipe,
    SortPipe,
    CheckPipe,
    PureFilterPipe,
    ButtonDatetimepickerComponent,
    NotificationViewComponent,
    UploadedFileViewComponent,
    ViewVideoModalComponent,
    VideoUploadBtnComponent,
    VideoLinkUploadModalComponent,
    FindObjPipe,
    RangeSliderComponent,
    StudentNamePipe
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// G:/UTL/Student/Student-ANG/src/app/shared/shared.module.ts